import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=0ad99885&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
import style0 from "./Video.vue?vue&type=style&index=0&id=0ad99885&prod&lang=css"
import style1 from "./Video.vue?vue&type=style&index=1&id=0ad99885&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad99885",
  null
  
)

export default component.exports